import t from "../../../helpers/t";
import Select from "react-select";
import { Div } from "../styled_components/exporter";
import React from "react";

const ProductsProductsSelect = (props) => {
  let returner = [];
  returner[153] = 154;
  returner[154] = 153;
  return (
    <>
      <Div className="inb-form-group column medium-6 small-12 lang">
        <label className="inb-form__controlLabel">{t("link_products", null, "capital")}</label>
        <span className="inb-form__controlLabel size-12">
          {t("link_products_help", null, "capital")}
        </span>

        <Select
          className="form-control"
          name="products"
          value={
            typeof props.product._products === "undefined"
              ? []
              : props.product._products.map((product) =>
                  typeof product.id !== "undefined" && product.required == 0
                    ? { value: product.id, label: product.name }
                    : product,
                )
          }
          isMulti="true"
          onChange={props.onChangeProductsWithOutRequired}
          placeholder={t("select_${a}", { a: t("product") })}
          theme={(theme) => ({
            ...theme,
            borderRadius: "3px",
            colors: {
              ...theme.colors,
              primary25: "#EB6A3A",
              primary: "#EB6A3A",
            },
          })}
          options={props.product.linkable_products[returner[props.parentId]].map((product) => {
            return {
              value: product.id,
              label: product.name,
              className: product.required > 0 ? "required" : "",
            };
          })}
        />
      </Div>
      {props.product.id !== "" && (
        <Div className="inb-form-group column medium-6 small-12 lang">
          <label className="inb-form__controlLabel">
            {t("link_required_products", null, "capital")}
          </label>
          <span className="inb-form__controlLabel size-12">
            {t("link_required_products_help", null, "capital")}
          </span>

          <Select
            className="form-control"
            name="required_products"
            value={
              typeof props.product._requiredProducts === "undefined"
                ? []
                : props.product._requiredProducts.map((product) =>
                    typeof product.id !== "undefined" && product.required > 0
                      ? {
                          value: product.id,
                          label: product.name,
                        }
                      : product,
                  )
            }
            isMulti="true"
            onChange={props.onChangeProducts}
            theme={(theme) => ({
              ...theme,
              borderRadius: "3px",
              colors: {
                ...theme.colors,
                primary25: "#EB6A3A",
                primary: "#EB6A3A",
              },
            })}
            placeholder={t("select_${a}", { a: t("required product") })}
            options={props.product.linkable_products[returner[props.parentId]].map((product) => {
              return {
                value: product.id,
                label: product.name,
                className: product.required > 0 ? "required" : "",
              };
            })}
          />
        </Div>
      )}
    </>
  );
};

export default ProductsProductsSelect;
